import { OfflineSearchSchema } from '@milestone-portal/schema/search.schema';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { Offline } from './-components/Offline';
import { useOffline } from './-logic/useOffline';
import { OfflineContext } from './-logic/useOfflineContext';

export const Route = createFileRoute('/_authed/offline/')({
  component: OfflinePage,
  validateSearch: zodValidator(OfflineSearchSchema),
});

function OfflinePage() {
  return (
    <OfflineContext.Provider value={useOffline()}>
      <Offline />
    </OfflineContext.Provider>
  );
}
